export default {"src":"/pro/_next/static/media/ape.9c843cf3.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};